import { Seo } from "../components/Seo";
import { PageHero } from "../components/PageHero";

const DOCS = {
  privacy: {
    title: "Privacy Policy",
    meta: "Privacy Policy for Shine Solutions, a commercial cleaning company in the Phoenix West Valley. Placeholder pending legal review.",
    sections: ["Information we collect", "How quote requests are processed (BookingKoala)", "How we use your information", "Third-party service providers", "Data retention", "Your choices and contact"],
  },
  terms: {
    title: "Terms of Service",
    meta: "Terms of Service for the Shine Solutions website and commercial cleaning services. Placeholder pending legal review and approval.",
    sections: ["Use of this website", "Quotes and proposals", "Service agreements", "Scheduling and cancellations", "Billing and payment", "Limitation of liability", "Governing law (Arizona)"],
  },
};

export default function Legal({ doc }) {
  const d = DOCS[doc];
  return (
    <>
      <Seo title={`${d.title} | Shine Solutions`} description={d.meta} path={`/${doc}`} />
      <PageHero kicker="Legal" lines={[d.title]} />
      <section className="bg-white py-20 md:py-28">
        <div className="mx-auto max-w-3xl px-5 md:px-10">
          <div className="rounded-2xl border border-amber-300 bg-amber-50 p-6 text-sm text-amber-900" data-testid="legal-placeholder-notice">
            <strong>Placeholder — not legal advice.</strong> This page is a structural outline awaiting drafting and approval by qualified legal counsel before launch.
          </div>
          <ol className="mt-12 space-y-10">
            {d.sections.map((s, i) => (
              <li key={s}>
                <h2 className="font-display text-2xl font-semibold text-ink">{i + 1}. {s}</h2>
                <p className="mt-3 text-base text-slate-600">[Section content to be provided by legal counsel.]</p>
              </li>
            ))}
          </ol>
        </div>
      </section>
    </>
  );
}
